import React, { PropsWithChildren } from 'react';
import { X } from 'react-feather';
import { Modal, ModalProps } from 'semantic-ui-react';
import styles from './styles/Popup.module.scss';
import Logo from 'components/logo';

interface IProps {
  showLogo?: boolean;
  showNav?: boolean;
}

const Popup = ({
  className,
  children,
  showCloseIcon,
  closeOnDimmerClick,
  open,
  showLogo,
  showNav,
  trigger,
  onClose,
  onOpen,
}: PropsWithChildren<IProps & ModalProps>) => {
  return (
    <Modal
      className={classnames(styles.modal, showNav && styles.nav, className)}
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      closeIcon={showCloseIcon ? <X className={styles.x} size={20} /> : false}
      closeOnDimmerClick={closeOnDimmerClick}
      closeOnEscape={closeOnDimmerClick}
      trigger={trigger}
    >
      {showLogo && (
        <div className={styles.logo}>
          <Logo small />
        </div>
      )}
      {children}
    </Modal>
  );
};

export default Popup;
